import React from 'react';
import CustomerNote from "components/setup/CustomerNote";
import BillingConfig from "components/setup/BillingConfig";
import { currentUser, duckify } from 'utils/duckify';

const BillingConfigPage = ({currentUser, props}) => {
  return <React.Fragment>
    {currentUser.acl >= 4 && <CustomerNote isSuperAdmin={'true'} userName={currentUser.name} pageName={'billing_config'}/>}
    <BillingConfig {...props}/>
  </React.Fragment>
}

const mapDucksToProps = () => ({ currentUser });
export default duckify(mapDucksToProps)(BillingConfigPage);
